module.exports = __webpack_public_path__ + "static/media/1_A1_16.5c78c88d.png";